import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { createContactfromOrder } from "../../../actions/contactAction";
import { getcontacttype } from "../../../actions/settings";
import {
  Form,
  Input,
  Checkbox,
  Drawer,
  Button,
  Col,
  Row,
  Select,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";

const { Option } = Select;

const CreateNewContact = ({
  createContactfromOrder,
  bill,
  setcontact,
  ContactList,
  getcontacttype,
  triggerOpen,
  phone,
  onClose: parentOnClose,
}) => {
  const initial = { remarks: "" };
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const phoneInputRef = useRef(null);

  const showDrawer = () => {
    getcontacttype();
    setVisible(true);
  };

  useEffect(() => {
    if (triggerOpen) {
      showDrawer();
    }
  }, [triggerOpen]);

  const onClose = () => {
    form.resetFields();
    setVisible(false);

    if (typeof parentOnClose === "function") {
      setTimeout(() => parentOnClose(), 300);
    }
  };

  const onFinish = (values) => {
    values.Type = "Customer";
    createContactfromOrder(values).then((result) => {
      form.resetFields();
      bill.current.Contact = result.id;
      setcontact(result);
      setVisible(false);

      if (typeof parentOnClose === "function") {
        setTimeout(() => parentOnClose(), 300);
      }
    });
  };

  // Auto-fill phone if provided
  useEffect(() => {
    if (visible && phone) {
      form.setFieldsValue({ phone });
    }
  }, [visible, phone, form]);

  // Auto-focus phone input
  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        if (phoneInputRef.current) {
          phoneInputRef.current.focus();
        }
      }, 200);
    }
  }, [visible]);

  return (
    <>
      <Button
        type="primary"
        onClick={showDrawer}
        style={{ marginBottom: "10px", float: "right" }}
      >
        <PlusOutlined /> New
      </Button>

      <Drawer
        title="Create a new Contact"
        width={720}
        onClose={onClose}
        visible={visible}
        bodyStyle={{ paddingBottom: 80 }}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={initial}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Name"
                rules={[
                  {
                    required: true,
                    message: "Please enter the customer name",
                  },
                ]}
              >
                <Input placeholder="Please enter customer name" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="email" label="Email">
                <Input
                  style={{ width: "100%" }}
                  addonBefore="@"
                  placeholder="Please enter Email"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="phone"
                label="Phone"
                rules={[
                  { required: true, message: "Please enter a phone number" },
                  {
                    pattern: /^[0-9]{11}$/,
                    message: "Phone number must be exactly 11 digits",
                  },
                ]}
              >
                <Input
                  placeholder="Please enter a valid 11-digit phone number"
                  ref={phoneInputRef}
                  maxLength={11}
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="role" label="Type">
                <Select placeholder="Please choose the type">
                  {ContactList.map((contact) => {
                    if (contact.Type === "Customer") {
                      return (
                        <Option key={contact.id} value={contact.id}>
                          {contact.name}
                        </Option>
                      );
                    }
                    return null;
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="address"
                label="Address"
                rules={[
                  {
                    required: true,
                    message: "Please enter an address",
                  },
                  {
                    min: 10,
                    message: "Address must be at least 10 characters long",
                  },
                ]}
              >
                <Input placeholder="Please enter address" />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item name="remarks" label="Remarks">
                <ReactQuill theme="snow" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="is_active"
                valuePropName="checked"
                initialValue={true}
              >
                <Checkbox>Active contact!</Checkbox>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Button onClick={onClose} style={{ marginRight: 8 }}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
};

const mapStateToProps = (state) => ({
  ContactList: state.contacts.contacttype,
});

export default connect(mapStateToProps, {
  createContactfromOrder,
  getcontacttype,
})(CreateNewContact);
